<template>
  <el-dialog
    :title="typeof costCentre.id !== 'undefined' ? 'Edit Cost Centre' : 'Create Cost Centre'"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="costCentreForm"
      v-loading="isSaving"
      :rules="rules"
      :model="costCentre"
      size="small"
    >
      <el-row>
        <el-col :md="24">
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Name"
                prop="name"
              >
                <el-input
                  v-model="costCentre.name"
                  placeholder="Name"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Code"
                prop="code"
              >
                <el-input
                  v-model="costCentre.description"
                  placeholder="Description"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof costCentre.id !== 'undefined' ? updateCostCentre() : createCostCentre()"
      >
        {{ typeof costCentre.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    costCentre: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isFullscreen: false,
      isLoadingServices: false,
      rules: {
        name: [
          { required: true, message: 'Name of the cost centre is required', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    createCostCentre () {
      this.$refs.costCentreForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.account_costcentre.create(this.costCentre, builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateCostCentre () {
      this.$refs.costCentreForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.costCentre.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
